import { personalizedSlipSchema } from "@redotech/redo-fulfillment-operations-common/personalized-slip/personalized-slip-definition";

export const updatePersonalizedSlipTemplate = {
  name: "updatePersonalizedSlipTemplate" as const,
  input: personalizedSlipSchema,
  output: personalizedSlipSchema,
};
